<template>
  <v-card class="pa-4 card flex-grow-1">
    <v-dialog v-model="deleteDialog" :key="deleteKey" max-width="300">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir o anexo') }}
            {{ attachToRemove.name }}?
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="remove"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-file-input id="fileinput" @change="setFile" class="d-none">
    </v-file-input>

    <v-btn icon text top right absolute @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <h3 class="text-center my-2">Anexos</h3>

    <v-row class="ma-0" dense justify="center">
      <v-col v-if="files.length == 0 && !loading">
        <div class="pa-2 text-center">
          <strong>{{ $t('Nenhum arquivo encontrado') }}...</strong>
        </div>
      </v-col>
      <v-col v-if="loading">
        <v-card class="primary-card pa-6 text-center">
          <v-progress-circular indeterminate size="25"></v-progress-circular>
        </v-card>
      </v-col>
      <v-col cols="auto" v-else v-for="file in files" :key="file.id">
        <v-card class="card pa-4 text-center" outlined>
          <h4>{{ file.name }}</h4>

          <v-btn
            block
            class="edit-button mt-2"
            small
            color="primary"
            outlined
            type="download"
            :href="
              file.path && file.path.includes('http')
                ? file.path
                : env + file.path
            "
            target="_blank"
          >
            {{ $t('Visualizar') }}
          </v-btn>
          <v-btn
            block
            class="delete-button mt-2"
            color="error"
            small
            outlined
            @click="openRemove(file)"
          >
            {{ $t('Remover') }}
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
    <div class="d-flex justify-end mt-3">
      <v-btn class="primary-button mr-1" depressed @click="openSelector">
        {{ $t('Adicionar') }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
export default {
  name: 'EntryAttachModal',

  props: {
    stockEntryId: Number,
  },

  data() {
    return {
      deleteDialog: false,
      deleteKey: false,
      loading: false,
      files: [],
      env: '',
      apiService: new ApiService(),
      attachToRemove: {},
    }
  },

  created() {
    this.getFiles()
    this.env = process.env.VUE_APP_BASE_URL
  },

  methods: {
    openRemove(file) {
      this.attachToRemove = file
      this.deleteKey = !this.deleteKey
      this.deleteDialog = true
    },

    openSelector() {
      document.getElementById('fileinput').click()
    },

    setFile(event) {
      this.loading = true
      const reader = new FileReader()
      reader.readAsDataURL(event)

      reader.onload = () => {
        const extension = event.name.split('.')[1]
        const file = {
          name: event.name,
          stockEntryId: this.stockEntryId,
          base64: reader.result,
          extension,
        }

        this.apiService
          .post(`stockEntryFile/add`, file)
          .then(() => {
            this.getFiles()
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    },

    getFiles() {
      this.loading = true
      this.apiService
        .get(`stockEntryFile/${this.stockEntryId}`)
        .then((response) => {
          this.files = response.content
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    remove() {
      this.loading = true
      this.apiService
        .delete(`stockEntryFile/${this.attachToRemove.id}`)
        .then(() => {
          this.getFiles()
          this.loading = false
          this.deleteDialog = false
          this.attachToRemove = {}
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.card {
  border-radius: 10px !important;
}
</style>
